import { commonjsGlobal as p } from "./index.es13.js";
import { __exports as o } from "./index.es90.js";
import b from "./index.es91.js";
import j from "./index.es92.js";
import x from "./index.es93.js";
import { __require as y } from "./index.es94.js";
var _;
function H() {
  if (_) return o;
  _ = 1;
  var a = p && p.__importDefault || function(r) {
    return r && r.__esModule ? r : { default: r };
  };
  Object.defineProperty(o, "__esModule", { value: !0 }), o.decodeHTML = o.decodeHTMLStrict = o.decodeXML = void 0;
  var c = a(b), s = a(j), v = a(x), i = a(y()), m = /&(?:[a-zA-Z0-9]+|#[xX][\da-fA-F]+|#\d+);/g;
  o.decodeXML = d(v.default), o.decodeHTMLStrict = d(c.default);
  function d(r) {
    var t = l(r);
    return function(e) {
      return String(e).replace(m, t);
    };
  }
  var f = function(r, t) {
    return r < t ? 1 : -1;
  };
  o.decodeHTML = function() {
    for (var r = Object.keys(s.default).sort(f), t = Object.keys(c.default).sort(f), e = 0, n = 0; e < t.length; e++)
      r[n] === t[e] ? (t[e] += ";?", n++) : t[e] += ";";
    var g = new RegExp("&(?:" + t.join("|") + "|#[xX][\\da-fA-F]+;?|#\\d+;?)", "g"), q = l(c.default);
    function M(u) {
      return u.substr(-1) !== ";" && (u += ";"), q(u);
    }
    return function(u) {
      return String(u).replace(g, M);
    };
  }();
  function l(r) {
    return function(e) {
      if (e.charAt(1) === "#") {
        var n = e.charAt(2);
        return n === "X" || n === "x" ? i.default(parseInt(e.substr(3), 16)) : i.default(parseInt(e.substr(2), 10));
      }
      return r[e.slice(1, -1)] || e;
    };
  }
  return o;
}
export {
  H as __require
};
//# sourceMappingURL=index.es88.js.map
